import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          email: Yup.string()
                                                    .email('Invalid email')
                                                    .required('Required'),
                                          phone: Yup.string(),
                                          description: Yup.string()
                                      });
